import { FlexColumn } from '@gorila-shared-ui/components';
import { FormControl } from 'baseui/form-control';
import { Alert } from 'baseui/icon';
import { Input } from 'baseui/input';
import { validate as validateEmail } from 'email-validator';
import { useEffect, useState } from 'react';
import { useStyles } from '../../hooks/useStyles';
import useUpdateEffect from '../../hooks/useUpdateEffect';

type Props = {
  label?: string;
  value?: string;
  onChange: (email: string) => void;
  required?: boolean;
  disabled?: boolean;
  isEmailValid?: (valid: boolean) => void;
  placeholder?: string;
  reset?: boolean;
};
export function LabeledEmailInput({
  label = 'Correo:',
  value,
  onChange,
  required = false,
  disabled = false,
  isEmailValid,
  placeholder,
  reset,
}: Readonly<Props>) {
  const { css, theme } = useStyles();
  const [isValid, setIsValid] = useState(false);
  const [isVisited, setIsVisited] = useState(false);
  const shouldShowError = !isValid && isVisited;

  useEffect(() => {
    if (!value) {
      setIsValid(!required);
      return;
    }
    setIsValid(validateEmail(value));
  }, [value]);

  useUpdateEffect(() => {
    if (isEmailValid) {
      isEmailValid(isValid);
    }
  }, [isValid]);

  useUpdateEffect(() => {
    setIsVisited(false);
  }, [reset]);

  const onInputChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { value } = event.currentTarget;
    onChange(value.trim());
  };

  return (
    <FlexColumn
      gap={theme.sizing.scale200}
      classNames={css({ width: '100%' })}
    >
      <FormControl
        label={label && `${label} ${required ? '*' : ''}`}
        disabled={disabled}
        overrides={{
          LabelContainer: {
            style: {
              marginTop: 0,
              marginBottom: 0,
            },
          },
          ControlContainer: {
            style: { marginBottom: 0 },
          },
        }}
        error={shouldShowError ? 'Ingrese un correo valido' : null}
      >
        <Input
          value={value}
          onChange={onInputChange}
          onBlur={() => setIsVisited(true)}
          size="compact"
          error={shouldShowError}
          placeholder={placeholder}
          endEnhancer={
            shouldShowError ? (
              <div
                className={css({
                  display: 'flex',
                  alignItems: 'center',
                  paddingRight: theme.sizing.scale500,
                  color: theme.colors.negative400,
                })}
              >
                <Alert size="18px" />
              </div>
            ) : (
              ''
            )
          }
        />
      </FormControl>
    </FlexColumn>
  );
}
